import React, { useContext, useState } from 'react';
import { defaultEventType, EventType } from '../../../../app/models/EventType';
import useEventTypeService from '../../../../app/services/hooks/useEventTypeService';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import EventTypeFormContainer from '../EventTypeFormContainer';
import LazyLoading from '../../../../components/LazyLoading';
import { AppContext } from '../../../../contexts/AppContext';
import useReactConfirmAlert from '../../../../hooks/useReactConfirmAlert';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const EventTypeCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingStoreEventType, storeEventType, createEventType, fetchingCreateEventType } =
        useEventTypeService();
    const [eventType, setEventType] = useState<EventType>(defaultEventType);

    const [errorFields, setErrorFields] = useState<any>();

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando evento...');
        storeEventType(eventType, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingCreateEventType ? (
        <LazyLoading height={300} />
    ) : (
        <EventTypeFormContainer
            fetching={fetchingStoreEventType}
            action={store}
            cancel={cancel}
            eventType={eventType}
            setEventType={setEventType}
            errorFields={errorFields}
        />
    );
};

export default EventTypeCreate;
